// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"filter-view-searchicon_searchIcon__OK3nx"};